/**
 * Libellé explicite remise Pass (règle + récompense) — caisse / ticket / rapports.
 */
import type { LoyaltyPassRule } from '../../types/loyaltyPass';

export type PassDiscountAwardLike = {
  ruleId: string;
  discountAmountXaf: number;
  reward?: { type?: string; value?: number; label?: string };
};

function fallbackRewardText(reward?: {
  type?: string;
  value?: number;
  label?: string;
}): string {
  const labeled = (reward?.label || '').trim();
  if (labeled) return labeled;
  const value = Number(reward?.value);
  if (!Number.isFinite(value)) return '';
  if (reward?.type === 'percent') return `−${value} %`;
  if (reward?.type === 'fixed') return `−${Math.round(value)} FCFA`;
  return '';
}

/**
 * Ex. « M1 · −10 % » ou « M1 · −10 % · G1 · −15 % ».
 */
export function formatLoyaltyPassDiscountLabel(
  awards: PassDiscountAwardLike[],
  rules: Array<Pick<LoyaltyPassRule, 'id' | 'name'>> = []
): string {
  if (!awards?.length) return '';
  const byId = new Map(rules.map((r) => [r.id, r.name]));
  const parts: string[] = [];
  for (const award of awards) {
    if (!(award.discountAmountXaf > 0)) continue;
    const ruleName = (byId.get(award.ruleId) || '').trim() || award.ruleId;
    const rewardText = fallbackRewardText(award.reward);
    parts.push(rewardText ? `${ruleName} · ${rewardText}` : ruleName);
  }
  return parts.join(' · ');
}
